import React from 'react';

const EditCreateBtn = ({className}) => (
  <svg className={className} viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.9298 6.78658L11.056 3.11056L3.99358 8.91922L6.651 12.4603L10.2891 9.66659L13.9298 6.78658Z" fill="white"/>
    <path d="M16.767 4.37399L13.9542 0.864594L12.1608 2.33962L14.9345 5.64444L16.767 4.37399Z" fill="white"/>
    <path d="M0.980231 14.2483L5.57583 13.1485L3.26378 9.85611L0.980231 14.2483Z" fill="white"/>
  </svg>

);

export default EditCreateBtn;
